let generation = 0;

export const getSessionGeneration = (): number => generation;

export const advanceSessionGeneration = (): number => ++generation;

export const isCurrentSession = (observedGeneration: number): boolean =>
  observedGeneration === generation;

export const assertCurrentSession = (observedGeneration: number): void => {
  if (!isCurrentSession(observedGeneration)) {
    throw new DOMException('Session changed', 'AbortError');
  }
};
